<nz-layout>
  <app-app-header (toggleMenu)="isCollapsed=!isCollapsed"></app-app-header>
  <nz-content class="outer-content">
    <nz-layout class="inner-layout">
      <nz-sider class="sidebar"
        nzWidth="256px"
        nzCollapsible
        [nzCollapsedWidth]="0"
        [(nzCollapsed)]="isCollapsed"
        [nzTrigger]="null"
        [nzBreakpoint]="'lg'"
        class="collapse-sidebar"
      >
        <app-sidebar></app-sidebar>
      </nz-sider>
      <nz-content class="content">
        <div class="inner-content">
          <router-outlet></router-outlet>
        </div>
      </nz-content>
    </nz-layout>
    <!-- <nz-footer></nz-footer> -->
  </nz-content>
</nz-layout>
